import { useQuery } from 'react-query';
import { getRequestCallbacks } from '../../apis/V2/requestCallback';

export const useGetRequestCallback = (source?: string) => {
	return useQuery({
		queryKey: ['getRequestCallbacks',source],
		queryFn: async () => (await getRequestCallbacks({ source })).data as any,
		staleTime: 60000,
		retry: false,
		refetchOnWindowFocus: false,
		enabled: true,
	});
};
